export default {
    task: {
        getMyCash: 'ನನ್ನ ನಗದು ಪಡೆಯಿರಿ',
        chances: 'ಅವಕಾಶಗಳು ಉಳಿದಿವೆ',
        tips: 'ಕಾರ್ಡ್‌ಗಳನ್ನು ಪಡೆಯಲು ಸಲಹೆಗಳು',
        daily: 'ದೈನಂದಿನ ಚೆಕ್-ಇನ್',
        watch: 'ಯಾವುದೇ ವೀಡಿಯೋ ನೋಡಿ',
        share: 'ಸ್ಪರ್ಧೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳಿ',
        free: 'ಉಚಿತ ನಗದು ಮತ್ತು ಕಾರ್ಡ್ +1',
        done: 'ಮುಗಿದಿದೆ',
        go: 'ಹೋಗಿ',

        success: 'ಯಶಸ್ವಿಯಾಗಿ',
        checkIn: 'ಚೆಕ್ ಇನ್',
        successCheckIn: 'ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',
        successWatched: 'ಯಶಸ್ವಿಯಾಗಿ ವೀಕ್ಷಿಸಲಾಗಿದೆ!',
        successShared: 'ಯಶಸ್ವಿಯಾಗಿ ಹಂಚಿಕೊಳ್ಳಲಾಗಿದೆ!',
        won: 'ನೀವು ಗೆದ್ದಿದ್ದೀರಿ',
        card: 'ಕಾರ್ಡ್',
        msg: 'ಹಣವನ್ನು ನಿಮ್ಮ ಖಾತೆಗೆ ಉಳಿಸಲಾಗಿದೆ',
        ok: 'ಸರಿ',
        nochance: 'ನೀವು ಎಲ್ಲವನ್ನೂ ಮುಗಿಸಿಲ್ಲ',
        cards: '4-ಕಾರ್ಡ್‌ಗಳು ',
        collection:'ಸಂಗ್ರಹ',
        watchVideo:'ವಿಡಿಯೋ ನೋಡಿ ',
        toGet:'ಹೆಚ್ಚಿನ ಕಾರ್ಡ್ ಪಡೆಯಲು'
    },
    
    rules: {
        ruleTitle: "ನಿಯಮಗಳು",
        validityDate: "ಮಾನ್ಯತೆ ದಿನಾಂಕ: 8ನೇ ಮಾರ್ಚ್,2020 - 15ನೇ ಮಾರ್ಚ್,2020",
        prizeRedeem: "ಬಹುಮಾನ ಪಡೆದುಕೊಳ್ಳಿ: ಉಳಿದಿರುವ 15 ರೂ. ತಲುಪಿದ ನಂತರ ಬಳಕೆದಾರರು ತಮ್ಮ ಹಣವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಬಹುದು, 7 ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ವ್ಯವಹಾರ ಪೂರ್ಣಗೊಳ್ಳುತ್ತದೆ",
        gameRule:{
            title:"ಆಟದ ನಿಯಮಗಳು:",
            ruleList: [
                "1. ಬಳಕೆದಾರರು ದೈನಂದಿನ ಚೆಕ್-ಇನ್ ಅನ್ನು ಮುಗಿಸಿದಾಗ ನಗದನ್ನು ಮತ್ತು 1 ಕಾರ್ಡ್ ಅನ್ನು ಪಡೆಯಬಹುದು ",
                "2. ಬಳಕೆದಾರರು ಯಾವುದೇ ವೀಡಿಯೊವನ್ನು ಪ್ರತಿದಿನ ನೋಡಿದಾಗ ನಗದನ್ನು ಮತ್ತು 1 ಕಾರ್ಡ್ ಅನ್ನು ಪಡೆಯಬಹುದು",
                "3. ಬಳಕೆದಾರರು ಚಟುವಟಿಕೆಯನ್ನು ವಾಟ್ಸಾಪ್ ಗ್ರೂಪ್ ಅಥವಾ ಫೇಸ್‌ಬುಕ್ ಅಥವಾ ಇನ್‌ಸ್ಟಾಗ್ರಾಮ್ ಮತ್ತು ಬೇರೆಲ್ಲಾದರೂ‌ ಹಂಚಿಕೊಂಡಾಗ ನಗದನ್ನು ಮತ್ತು 1 ಕಾರ್ಡ್ ಅನ್ನು ಪಡೆಯಬಹುದು",
                "4. ಒಮ್ಮೆ ಎಲ್ಲಾ 4 ಕಾರ್ಡ್‌ಗಳನ್ನು ಸಂಗ್ರಹಿಸಿದ ನಂತರ, ಬಳಕೆದಾರರು ಲಾಟರಿ ಡ್ರಾ ಮಾಡುವ ಅವಕಾಶವನ್ನು ಪಡೆಯಬಹುದು. ಪ್ರತಿ ಲಕ್ಕಿ ಡ್ರಾ 100% -ಖಚಿತ- ಗರಿಷ್ಠ 3 ಮಿಲಿಯನ್ ರೂಪಾಯಿ ನಗದಿನಲ್ಲಿ  ಪ್ರತಿಯೊಬ್ಬ ಬಳಕೆದಾರರು 20000 ರೂ. ಅನ್ನು ಲಕ್ಕಿ ಡ್ರಾದಲ್ಲಿ ಗೆಲ್ಲಿರಿ"
            ]
        },
        msg:"ಅಂತಿಮ ವಿವರಣೆಗಾಗಿ SHAREit‌ ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸುತ್ತದೆ"
    },
    share: {
        title:"*ತಮಾಷೆಯಲ್ಲ, ಸ್ನೇಹಿತರೇ, ಈ ಹೋಳಿಯು, SHAREit‌ 30 ಲಕ್ಷ ನೈಜ ನಗದನ್ನು ಕೊಡುತ್ತದೆ!*😊\n*ನನ್ನೊಂದಿಗೆ ಸೇರಿಕೊಳ್ಳಿ ಮತ್ತು 20000  ರೂ. ಅನ್ನು ಪಡೆಯಲು ವೀಡಿಯೊಗಳನ್ನು ನೋಡಿ, ಎಲ್ಲರೂ 100% ಗೆಲ್ಲುತ್ತಾರೆ.*💰\n*ನಾನು ಈಗಾಗಲೇ ಉಚಿತ ಹಣವನ್ನು ಪಡೆದುಕೊಂಡಿದ್ದೇನೆ, ಇದು 100% ನಿಜ.*\n*ಈಗ SHAREit‌ ನ ಹೋಳಿ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಭಾಗವಹಿಸೊಣ!*💕👇🏻👇🏻👇🏻"
    }
}